import React from 'react';
import styled from 'styled-components';

import HorizontalLayout from '@rover/react-lib/src/components/layouts/HorizontalLayout';
import { Alignment } from '@rover/react-lib/src/components/layouts/layout.constants';
import LoadingSpinner from '@rover/react-lib/src/components/typography/LoadingSpinner';

const StyledHorizontalLayout = styled(HorizontalLayout)`
  width: 100%;
  padding: 50px;
`;

const StyledLoadingSpinner = styled(LoadingSpinner)`
  font-size: 50px;
`;

const Loading = (): JSX.Element => (
  <StyledHorizontalLayout hAlign={Alignment.CENTER} vAlign={Alignment.CENTER}>
    <StyledLoadingSpinner />
  </StyledHorizontalLayout>
);

export default Loading;
